import ComponentCard from "../../../../components/common/ComponentCard";
import PageMeta from "../../../../components/common/PageMeta";
import Button from "../../../../components/ui/button/Button";
import { useNavigate } from "react-router-dom";
import ReasonsTaskNotCompletedTable from "./ReasonsTaskNotCompletedTable";

const ReasonsTaskNotCompleted = () => {
  const navigate = useNavigate();

  return(
    <>
      <PageMeta 
        title="Workflows - Reasons Task Not Completed | Hospitality Genie"
        description="Workflows - Reasons Task Not Completed"
      />
      <div className="space-y-6">
      <ComponentCard title="Workflows - Reasons Task Not Completed">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">Reasons Task Not Completed</div>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <button
                className="inline-flex items-center gap-2 px-4 py-3 text-sm font-medium text-[#ffffed] rounded-lg bg-[#142900] hover:bg-[#e1ffb4] hover:text-[#142900]"
              >
                Filter Options
              </button>
            <Button
              className="inline-flex items-center gap-2 px-4 py-3 text-sm font-medium rounded-lg bg-[#142900] hover:bg-[#3d5e42]" size="sm" 
              onClick={() => navigate('/add-new-reason-task-not-completed')}
            >
              Add New Reasons Task Not Completed
            </Button>
            </div>
        </div>
        
        <div>
          {/* Table Component */}
            <ReasonsTaskNotCompletedTable />
        </div>
      </ComponentCard>
      </div>
    </>
  );

}

export default ReasonsTaskNotCompleted;